import type { RichTextElement, RichTextProps } from './rich-text.types';
import type { StructuredText } from '@/types/prismic/common';

export const getRichTextPlainText = (
    field?: RichTextProps['content'] | StructuredText | StructuredText[] | null
): string => {
    if (!field) {
        return '';
    }

    if (typeof field === 'string') {
        return field.trim();
    }

    if (Array.isArray(field)) {
        return field
            .map((node) => node.text ?? '')
            .join(' ')
            .trim();
    }

    return (field?.text ?? '').trim();
};

export const getHeadingText = (content?: RichTextElement[]) => {
    if (!content?.length) {
        return '';
    }

    const heading = content.find((element) => element.type?.startsWith('heading'));
    return (heading?.text ?? content[0]?.text ?? '').trim();
};

export const hasRichTextContent = (content?: RichTextProps['content']) => {
    if (!content) {
        return false;
    }

    if (typeof content === 'string') {
        return Boolean(content.trim());
    }

    return Boolean(content.some((element) => element.text?.trim()));
};

export const toRichTextContent = (content?: RichTextProps['content']): RichTextElement[] => {
    if (!content) {
        return [];
    }

    if (typeof content === 'string') {
        const text = content.trim();
        return text ? [{ type: 'paragraph', text }] : [];
    }

    return content;
};
